import { ScheduleAdditionsTab } from 'src/app/features/events/itinerary/schedule-additions/axle-schedule-additions.models';

export function scheduleAdditionsHref(
  eventId: string,
  tab: ScheduleAdditionsTab
) {
  return `/events/${eventId}/itinerary/scheduleAdditions/${tab}`;
}
